import React from 'react';
import Link from 'next/link';
import { Row, Col, List, Card } from 'antd';
import SocialShare from '@/components/SocialShare';

const ProductsPage = () => {
  return (
    <div>
      <section className="help-center section hero v9">
        <div className="container-default w-container">
          <div className="z-index-1">
            <div className="mg-bottom-78px">
              <div className="inner-container center">
                <div className="inner-container _861px---tablet center">
                  <div className="text-center">
                    <div className="mg-bottom-24px">
                      <div className="text-100 bold color-accent-1 text-uppercase">
                        Brandymail™ Products
                      </div>
                    </div>
                    <h1 className="display-1 color-neutral-100 mg-bottom-24px">Select a Product</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute card-top-bg---bottom pricing-bg" />
      </section>
      <div className="overflow-hidden border-radius-40px---bottom">
        <section className="section pd-top-0px bg-neutral-100 pd-0px">
          <div className="container-default w-container inner-container center">
            <Row gutter={[48, 48]}>
              <Col xs={24} md={16}>
                <h2>Email Branding &amp; Security</h2>
                <List bordered={false} split={true} className="mg-bottom-48px">
                  <List.Item key="1">
                    <Link href="/products/digicert-verified-mark-certificate">
                      Verified Mark Certificate
                    </Link>
                  </List.Item>
                </List>
              </Col>
              <Col xs={24} md={8}>
                <Card
                  className="card post-author"
                  style={{
                    position: 'sticky',
                    top: '0',
                  }}
                >
                  <h4>Share this Products page</h4>
                  <SocialShare url="https://brandymail.com/products" title="Brandymail Products" />
                </Card>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProductsPage;
